(ns app.front.view.admin.gis.common
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.event :refer [>evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(defn system-of-type? [server-config & types]
  (->> server-config
       :gis-server-config/system
       (contains? (set types))))


(defn arcgis-server? [server-config]
  (system-of-type? server-config :arcgis))


(defn wms-wfs-server? [server-config]
  (system-of-type? server-config :wms-wfs))


(defn cgis-server? [server-config]
  (system-of-type? server-config :cgis))


(rf/reg-event-fx ::fetch-arcgis-server-information
  (fn [_ [_ server-config path on-success]]
    (when (or (arcgis-server? server-config)
              (system-of-type? server-config :azimut-arcgis)
              (system-of-type? server-config :regrid-arcgis))
      {:comm/command {:command    :admin/arcgis-proxy
                      :method     :get
                      :data       {:gis-server-id (:db/id server-config)
                                   :path          path}
                      :on-success on-success}})))


(defn format-services [services]
  (->> services
       (map (fn [{:keys [name type]}]
              {:gis-service-config/arcgis-service      (-> (str/split name #"/")
                                                           last)
               :gis-service-config/arcgis-service-type type}))))


(defn format-layers [layers]
  (->> layers
       (reduce (fn [acc {:keys [id name]}]
                 (assoc acc id {:name name}))
               {})))


(rf/reg-event-db ::arcgis-server-root-info-fetched
  (fn [db [_ server-id _ {:keys [folders services]}]]
    (cond-> (reduce (fn [db folder-name]
                      (update-in db [::arcgis-server-info server-id folder-name] (fnil identity [])))
                    db
                    folders)
      (seq services) (assoc-in [::arcgis-server-info server-id ""] (format-services services)))))


(rf/reg-event-fx ::arcgis-folder-info-fetched
  (fn [{:keys [db]} [_ server-id folder _ {:keys [services]}]]
    (when (seq services)
      {:db (assoc-in db [::arcgis-server-info server-id (or folder "")] (format-services services))})))


(rf/reg-event-fx ::arcgis-service-info-fetched
  (fn [{:keys [db]} [_ server-id folder service _ {:keys [layers fullExtent]}]]
    (when (seq layers)
      {:db (-> db
               (assoc-in [::arcgis-service-info server-id (or folder "") service :layers] (format-layers layers))
               (assoc-in [::arcgis-service-info server-id (or folder "") service :extent] fullExtent))})))


(rf/reg-event-fx ::fetch-azimut-arcgis-information
  (fn [_ [_ server-config editor-k]]
    (let [server-id   (:db/id server-config)
          service-key {:gis-service-config/arcgis-service      ""
                       :gis-service-config/arcgis-service-type "MapServer"}]
      {:fx [[:dispatch [::fetch-arcgis-server-information
                        server-config
                        "/MapServer"
                        [::arcgis-service-info-fetched
                         server-id
                         ""
                         service-key]]]
            [:dispatch [::set-editor-value
                        editor-k
                        server-id
                        :new
                        (merge {:gis-service-config/arcgis-folder  ""
                                :gis-search-config/arcgis-layer-id nil}
                               service-key)]]]})))


(rf/reg-event-fx ::arcgis-layer-info-fetched
  (fn [{:keys [db]} [_ server-id folder service layer-id _ resp]]
    (let [folder-id       (or folder "")
          last-coordinate (-> db ::last-coordinate (get server-id))
          last-query-type (-> db ::last-query-type (get server-id))]
      {:db       (assoc-in db [::arcgis-service-info server-id folder-id service :layers layer-id] resp)
       :dispatch [::fetch-arcgis-sample server-id folder service layer-id last-query-type last-coordinate]})))


(rf/reg-event-fx ::fetch-arcgis-sample
  (fn [{:keys [db]} [_ server-id folder service layer-id query-type coordinates]]
    {:comm/command {:command    :admin/arcgis-sample-record
                    :method     :post
                    :data       (p/remove-vals
                                  #(or (nil? %) (and (string? %) (str/blank? %)))
                                  {:gis-server-id                          server-id
                                   :gis-service-config/arcgis-folder       folder
                                   :gis-service-config/arcgis-service      (:gis-service-config/arcgis-service service)
                                   :gis-service-config/arcgis-service-type (:gis-service-config/arcgis-service-type service)
                                   :gis-search-config/arcgis-layer-id      layer-id
                                   :query-type                             query-type
                                   :coordinates                            coordinates})
                    :on-success [::arcgis-sample-fetched server-id folder service layer-id]}
     ;; store coordinate so that changing layer etc will cause sample to be fetched from the same location
     :db           (-> db
                       (assoc-in [::last-coordinate server-id] coordinates)
                       (assoc-in [::last-query-type server-id] query-type)
                       (p/dissoc-in [::forced-map-center server-id]))}))

(rf/reg-event-fx ::instantly-complete-arcgis-selections
  (fn [{:keys [db]} [_ server-config folder service service-type layer-id]]
    (let [server-id   (:db/id server-config)
          service-key {:gis-service-config/arcgis-service      service
                       :gis-service-config/arcgis-service-type service-type}]
      {:db (assoc-in db [::arcgis-server-info server-id folder] [service-key])
       :fx (concat [[:dispatch [::fetch-arcgis-server-information
                                server-config
                                (->> [folder service service-type]
                                     (remove str/blank?)
                                     (str/join "/")
                                     (str "/"))
                                [::arcgis-service-info-fetched
                                 server-id
                                 folder
                                 service-key]]]]
                   (when layer-id
                     [[:dispatch [::fetch-arcgis-server-information
                                  server-config
                                  (->> [folder service service-type layer-id]
                                       (remove str/blank?)
                                       (str/join "/")
                                       (str "/"))
                                  [::arcgis-layer-info-fetched
                                   server-id
                                   folder
                                   service-key
                                   layer-id]]]]))})))

(rf/reg-sub ::last-coordinate
  (fn [db [_ server-id]]
    (-> db ::last-coordinate (get server-id))))

(rf/reg-sub ::last-query-type
  (fn [db [_ server-id]]
    (-> db ::last-query-type (get server-id))))

(rf/reg-event-fx ::fetch-cgis-sample
  (fn [_ [_ server-id]]
    {:comm/command {:command    :admin/cgis-sample-record
                    :method     :post
                    :data       {:gis-server-id server-id}
                    :on-success [::cgis-sample-fetched server-id]}}))


(rf/reg-event-db ::arcgis-sample-fetched
  (fn [db [_ server-id folder service layer-id _ resp]]
    (assoc-in db [::arcgis-service-info server-id (or folder "") service :layers layer-id :sample-records] resp)))


(rf/reg-event-db ::cgis-sample-fetched
  (fn [db [_ server-id _ resp]]
    (assoc-in db [::cgis-service-info server-id :sample-record] resp)))


(rf/reg-event-db ::force-map-center
  (fn [db [_ server-id new-center]]
    (assoc-in db [::forced-map-center server-id] new-center)))


(rf/reg-sub ::forced-map-center
  (fn [db [_ server-id]]
    (get-in db [::forced-map-center server-id])))


(rf/reg-sub ::arcgis-server-info
  (fn [db [_ server-id]]
    (get-in db [::arcgis-server-info server-id])))


(rf/reg-sub ::arcgis-service-info
  (fn [db [_ server-id folder service]]
    (get-in db [::arcgis-service-info server-id folder service])))

(rf/reg-sub ::arcgis-layers
  (fn [[_ server-id folder service]]
    (rf/subscribe [::arcgis-service-info server-id folder service]))
  :-> :layers)

(rf/reg-sub ::arcgis-selected-layer-data
  (fn [[_ server-id folder-id service-id _]]
    (rf/subscribe [::arcgis-layers server-id folder-id service-id]))
  (fn [layers [_ _ _ _ layer-id]]
    (get layers layer-id)))

(rf/reg-sub ::arcgis-sample-records
  (fn [[_ server-id folder-id service-id layer-id]]
    (rf/subscribe [::arcgis-selected-layer-data server-id folder-id service-id layer-id]))
  :-> :sample-records)

(defn- samples-signal [[_ server-id folder-id service-id layer-id]]
  (rf/subscribe [::arcgis-sample-records server-id folder-id service-id layer-id]))

(rf/reg-sub ::arcgis-samples-loaded?
  samples-signal
  :-> boolean)

(rf/reg-sub ::arcgis-attribute-types
  samples-signal
  (fn [samples _]
    (-> samples first :attribute-types)))

(defn get-attributes [sample]
  (->> sample :attributes (p/map-keys name) (sort-by first)))

(rf/reg-sub ::arcgis-attribute-names
  samples-signal
  (fn [samples _]
    ;; assume attributes are common among records
    (->> samples first get-attributes (map first))))

(rf/reg-sub ::cgis-service-info
  (fn [db [_ server-id]]
    (get-in db [::cgis-service-info server-id])))


(rf/reg-event-db ::set-editor-value
  (fn [db [_ db-key server-id config-id partial-config]]
    (update-in db
               [db-key server-id config-id]
               (fn [old-config]
                 (->> (-> (p/deep-merge old-config partial-config)
                          (update :gis-search-config/mapping #(p/remove-vals nil? %))
                          (update :gis-search-config/property-search-config #(p/remove-vals nil? %)))
                      (p/remove-vals nil?))))))


(rf/reg-event-db ::add-domain-group
  (fn [db [_ db-key server-id config-id group-id]]
    (update-in db [db-key server-id config-id :group-ids] (comp set conj) group-id)))


(rf/reg-event-db ::remove-domain-group
  (fn [db [_ db-key server-id config-id group-id]]
    (update-in db [db-key server-id config-id :group-ids] (comp set disj) group-id)))


(rf/reg-event-fx ::save-config
  (fn [{:keys [db]} [_ command-k db-key server-id config-id config]]
    {:db           (assoc db ::save-in-progress? true)
     :comm/command {:command          command-k
                    :method           :post
                    :data             (merge {:gis-service-config/gis-server-config server-id}
                                             (p/remove-vals #(and (string? %)
                                                                  (str/blank? %))
                                                            config)
                                             (when (not= :new config-id)
                                               {:id config-id}))
                    :notify           {:success :gis-editor/config-saved}
                    :on-success       [::save-config.success db-key server-id config-id]
                    :finally-dispatch [::save-config.done]}}))


(rf/reg-event-fx ::save-config.success
  (fn [{:keys [db]} [_ db-key server-id config-id status changes]]
    {:db       (p/dissoc-in db [db-key server-id config-id])
     :dispatch [::entities/apply-changes status changes]}))


(rf/reg-event-db ::save-config.done
  #(dissoc % ::save-in-progress?))


(rf/reg-sub ::save-in-progress? #(-> % ::save-in-progress? boolean))


(rf/reg-event-fx ::remove-config
  (fn [_ [_ command-k config-id]]
    {:comm/command {:command    command-k
                    :method     :post
                    :data       {:id config-id}
                    :notify     {:success :gis-editor/remove-success}
                    :on-success [::entities/apply-changes]}}))


(def form-item acommon/form-item)


(defn fetch-arcgis-server-info-for-edit
  [{server-id :db/id :as server-config}
   {:keys [:gis-service-config/arcgis-folder
           :gis-service-config/arcgis-service
           :gis-service-config/arcgis-service-type
           :gis-search-config/arcgis-layer-id]
    :as   config}]
  (let [service-key (select-keys config [:gis-service-config/arcgis-service
                                         :gis-service-config/arcgis-service-type])]
    (when-not (system-of-type? server-config :azimut-arcgis :regrid-arcgis)
      (>evt [::fetch-arcgis-server-information
             server-config
             ""
             [::arcgis-server-root-info-fetched server-id]]))
    (when-not (str/blank? arcgis-folder)
      (>evt [::fetch-arcgis-server-information
             server-config
             (str "/" arcgis-folder)
             [::arcgis-folder-info-fetched server-id arcgis-folder]]))
    (>evt [::fetch-arcgis-server-information
           server-config
           (->> [""
                 arcgis-folder
                 arcgis-service
                 arcgis-service-type]
                (remove nil?)
                (str/join "/"))
           [::arcgis-service-info-fetched server-id arcgis-folder service-key]])
    (when arcgis-layer-id
      (>evt [::fetch-arcgis-server-information
             server-config
             (->> [""
                   arcgis-folder
                   arcgis-service
                   arcgis-service-type
                   arcgis-layer-id]
                  (remove nil?)
                  (str/join "/"))
             [::arcgis-layer-info-fetched server-id arcgis-folder service-key arcgis-layer-id]]))))
